/**
 * Editorial Grid System
 *
 * Clones .grid-item elements from a hidden source container into a CSS Grid
 * container as direct children so CSS grid positioning works.
 *
 * This indirection is required because Shopify wraps {%- render block -%}
 * output in <shopify-block> elements, which breaks grid-column / grid-row
 * on the .grid-item itself.
 */
(function () {
  /**
   * Position all grid items for one editorial section.
   * @param {Element} sectionEl — the section wrapper (contains .hidden-blocks and .editorial-grid-container)
   */
  function positionGrid(sectionEl) {
    const hiddenBlocks = sectionEl.querySelector(".hidden-blocks");
    const grid = sectionEl.querySelector(".editorial-grid-container");
    if (!hiddenBlocks || !grid) return;

    // Clear any previously cloned items
    grid.querySelectorAll(".positioned-grid-item").forEach((el) => el.remove());

    // Clone each .grid-item from the hidden source into the CSS grid
    hiddenBlocks.querySelectorAll(".grid-item").forEach((gridItem) => {
      const positioned = document.createElement("div");
      positioned.className = gridItem.className + " positioned-grid-item";
      if (gridItem.style.cssText) {
        positioned.style.cssText = gridItem.style.cssText;
      }
      Array.from(gridItem.children).forEach((child) => {
        positioned.appendChild(child.cloneNode(true));
      });
      grid.appendChild(positioned);
    });
  }

  /** Run positionGrid for every editorial section on the page. */
  function positionAll() {
    document
      .querySelectorAll(".editorial-grid-section")
      .forEach((section) => positionGrid(section));
  }

  // --- Initial positioning ---------------------------------------------------

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", positionAll);
  } else {
    positionAll();
  }

  // --- Theme editor events (only fire inside the Shopify admin) --------------

  // Section re-rendered (settings change, block add/remove, reorder, etc.)
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target;
    if (section && section.querySelector(".editorial-grid-container")) {
      // Short delay lets the DOM fully settle after Shopify's replacement
      setTimeout(() => positionGrid(section), 50);
    }
  });

  // Block selected / deselected in the sidebar — re-clone in case block HTML changed
  document.addEventListener("shopify:block:select", (e) => {
    const section =
      e.target.closest(".editorial-grid-section") ||
      e.target.closest("[id^='shopify-section-']");
    if (section) setTimeout(() => positionGrid(section), 50);
  });

  document.addEventListener("shopify:block:deselect", (e) => {
    const section =
      e.target.closest(".editorial-grid-section") ||
      e.target.closest("[id^='shopify-section-']");
    if (section) setTimeout(() => positionGrid(section), 50);
  });
})();
